import React from 'react';
import InfoListingPage from '../components/InfoListingPage';

const items = [
  {
    title: 'Mount Edgcumbe House',
    distance: '11.4 miles from the hotel',
    image: 'MountEdgcumbe.jpg',
    description: 'If you want to spend a day away from the city, Mount Edgcumbe House and Country Park is the place to visit. The former home of the Earls of Mount Edgcumbe is a Grade II listed building, while its gardens and parkland are listed as Grade I in the Register of Parks.\n\nWhile visiting Mount Edgecumbe House, do not forget to visit the romantic and picturesque Orangery, a garden café, where you can enjoy a leisurely cream tea or lunch while looking at stunning views of the historic Italian Garden and water fountain.\n\nThe house and garden are open from April to September, with the wider park open year-round, daily from 8am to dusk, and are free to the public.'
  },
  {
    title: 'Saltram House',
    distance: '5.5 miles from the hotel',
    image: 'SaltramHouse.jpg',
    description: 'A glorious Georgian style mansion with serene gardens that lie at the heart of this historic parkland, Saltram House is considered to be one of the hidden treasures of the area. A close drive from Plymouth, this magnificent house tends to amaze its visitors with original items that speak the story of the life of the rich and elite that once resided on this country-estate. Perfect for picnics, cycling, spotting wildlife, this half-day trip is worth considering while in Plymouth.'
  },
  {
    title: 'Dartmoor Park',
    distance: '9.8 miles from the hotel',
    image: 'DartmoorPark.jpg',
    description: 'A stunning landscape set against the countryside of areas surrounding Plymouth, Dartmoor is certainly worth a day trip. From wild ponies to impeccable history and heritage, visiting this park is an unforgettable experience of its own. This breathtaking landscape should definitely be on your list of places to see while in Plymouth!'
  },
  {
    title: 'Whitsand Bay',
    distance: '19.6 miles from the hotel',
    image: 'WhitsandBay.jpg',
    description: 'The beach of Whitsand Bay offers over three miles of stunning sand from Rame Head to Portwrinkle and is considered one of Cornwall’s hidden gems. Reached by steep paths and steps that wind down between the verdant vegetation, these beaches are never crowded. At low tide, the long stretches of glistening sand provide great walking or jogging opportunities, whilst the constant swell keeps surfers happy riding some huge waves.'
  },
  {
    title: 'Cawsand Island',
    distance: '10 miles from the hotel',
    image: 'CawsandIsland.jpg',
    description: 'With boat trips from Plymouth and plenty of little bars and restaurants nearby, the pretty village of Cawsand has a lot to offer the typical holidaymaker. The beach is sandy and the views are exceptional out over the bay.'
  },
  {
    title: 'Eden Project',
    distance: 'A great family day out from the hotel',
    image: 'EdenProject.jpg',
    description: 'The Eden Project in Cornwall is a great day out for the whole family - explore the largest indoor rainforest in the world and enjoy the two biomes with plants that are collected from many diverse climates and environments. There is so much going on - make sure you do not miss anything.'
  },
  {
    title: 'Plymouth Life Centre / Central Park',
    distance: 'Within easy reach of the hotel',
    image: 'PlymouthLifeCentre.jpg',
    description: 'Plymouth Life Centre is more than just a sports centre, it’s one of the county’s leading sports venues. It features one of the city’s largest fitness and sports areas, while the aquatic facilities are second to none. It is also right beside Central Park - the largest park in Plymouth. Its open woodlands, gardens, café, skate park, tennis courts and pitch and putt, footgolf and Frisbee golf courses make for a full day out.'
  }
];

const NearbyAttractions = () => (
  <InfoListingPage
    title="Nearby Attractions"
    description="Explore memorable day trips and family attractions within easy reach of Grosvenor Plymouth, from historic estates to countryside escapes and coastal favourites."
    items={items}
  />
);

export default NearbyAttractions;
